import axios from "axios";
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
////////////////////////////////////////////////////////////
/////////////////////////LOGIN////////////////////////////
////////////////////////////////////////////////////////////
type api_post_login_type = {
  email: string;
  password: string;
};
async function api_post_login(args: api_post_login_type) {
  try {
    const { email, password } = args;
    const response = await axios.post(
      API_BASE_URL + "/login",
      {
        email,
        password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    //console.log('====POST_LOGIN API====');
    if (axios.isAxiosError(error)) {
      if (error.response) {
        return error.response;
      }
    }
    throw error;
  }
}

type api_refresh_access_token_type = {
  userId: string;
};
async function api_refresh_access_token(args: api_refresh_access_token_type) {
  try {
    const userId = args["userId"];
    const response = await fetch(API_BASE_URL + "/refresh?userId=" + userId, {
      method: "POST",
    });
    const data = await response.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.log("====REFRESH_ACCESS_TOKEN API====");
    console.log(error);
    throw error;
  }
}

type api_post_signup_type = {
  email: string;
  password: string;
  name: string;
  phoneNumber: string;
  salesType: string;
  funnels: string;
  funnelsOther: string;
  brand: string;
  brandLink: string;
  country: string;
  dialCode: string;
  invitedByCode: string;
  deviceInfo: string;
};
async function api_post_signup(args: api_post_signup_type) {
  try {
    const email = args["email"];
    const password = args["password"];
    const name = args["name"];
    const phoneNumber = args["phoneNumber"];
    const salesType = args["salesType"];
    const funnels = args["funnels"];
    const funnelsOther = args["funnelsOther"];
    const brand = args["brand"];
    const brandLink = args["brandLink"];
    const country = args["country"];
    const dialCode = args["dialCode"];
    const invitedByCode = args["invitedByCode"];
    const deviceInfo = args["deviceInfo"];
    // + 기호를 이스케이프 처리하고, dialCode도 이스케이프 처리
    const escapedDialCode = dialCode.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const actualPhoneNumber = phoneNumber
      .replace(/^\+/, "")
      .replace(new RegExp(`^${escapedDialCode}`), "")
      .trim();
    // console.log(actualPhoneNumber);
    // console.log(country);
    // console.log(dialCode);

    const response = await fetch(API_BASE_URL + "/signup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        password: password,
        name: name,
        phoneNumber: actualPhoneNumber,
        salesType: salesType,
        funnels: funnels,
        funnelsOther: funnelsOther,
        brand: brand,
        brandLink: brandLink,
        country: country,
        dialCode: dialCode,
        invitedByCode: invitedByCode,
        deviceInfo: deviceInfo,
      }),
    });
    return response;
  } catch (error) {
    console.log("====POST_SIGNUP API====");
    console.log(error);
    throw error;
  }
}

type api_post_social_signup_type = {
  userId: string;
  salesType: string;
  brand: string;
  brandLink: string;
  funnels: string;
  funnelsOther: string;
  invitedByCode: string;
  phoneNumber: string;
  deviceInfo: string;
};
async function api_post_social_signup(args: api_post_social_signup_type) {
  try {
    //console.log('api_post_social_signup', args);
    const userId = args["userId"];
    const salesType = args["salesType"];
    const brand = args["brand"];
    const brandLink = args["brandLink"];
    const funnels = args["funnels"];
    const funnelsOther = args["funnelsOther"];
    const invitedByCode = args["invitedByCode"];
    const phoneNumber = args["phoneNumber"];
    const deviceInfo = args["deviceInfo"];
    const response = await fetch(API_BASE_URL + "/signup/social", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: userId,
        salesType: salesType,
        brand: brand,
        brandLink: brandLink,
        funnels: funnels,
        funnelsOther: funnelsOther,
        invitedByCode: invitedByCode,
        phoneNumber: phoneNumber,
        deviceInfo: deviceInfo,
      }),
    });
    return response;
  } catch (error) {
    console.log("====POST_SOCIAL_SIGNUP API====");
    console.log(error);
    throw error;
  }
}

// 추천인 코드 검증
type api_get_check_referral_code_type = {
  referral_code: string;
};
async function api_get_check_referral_code(args: api_get_check_referral_code_type) {
  try {
    const referral_code = args["referral_code"];
    const response = await fetch(
      API_BASE_URL + `/check_referral_code?referral_code=${referral_code}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====GET_CHECK_REFERRAL_CODE API====");
    console.log(error);
    throw error;
  }
}

// 쿠폰 코드 검증
type api_post_check_coupon_code_type = {
  coupon_code: string;
  accessToken: string;
};
async function api_post_check_coupon_code(args: api_post_check_coupon_code_type) {
  try {
    const coupon_code = args["coupon_code"];
    const accessToken = args["accessToken"];
    const response = await fetch(API_BASE_URL + `/promotion_code_validation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify({
        coupon_code: coupon_code,
      }),
    });
    return response.json();
  } catch (error) {
    console.log("====POST_CHECK_COUPON_CODE API====");
    console.log(error);
    throw error;
  }
}

// 전화번호  인증번호 요청
async function api_post_phone_number_validation(phone_number: string) {
  try {
    const response = await fetch(`${API_BASE_URL}/send_sms`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        phone_number: phone_number,
      }),
    });
    return response;
  } catch (error) {
    console.log("====POST_PHONE_NUMBER_VALIDATION API====");
    console.log(error);
    throw error;
  }
}

// 국제 전화번호 인증번호 요청
async function api_post_international_phone_number_validation(phone_number: string) {
  try {
    const response = await fetch(`${API_BASE_URL}/twilio_message/send_verification_code`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        phone_number: phone_number,
      }),
    });
    //console.log('response', response);
    return response;
  } catch (error) {
    console.log("====POST_PHONE_NUMBER_VALIDATION API====");
    console.log(error);
    throw error;
  }
}

// 기존 유저 휴대폰 번호 인증 번호 요청
type api_post_phone_number_validation_existing_user_type = {
  phone_number: string;
  accessToken: string;
};
async function api_post_phone_number_validation_existing_user(
  args: api_post_phone_number_validation_existing_user_type
) {
  try {
    const accessToken = args["accessToken"];
    const phone_number = args["phone_number"];
    const response = await fetch(`${API_BASE_URL}/info/send_sms`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify({
        phone_number: phone_number,
      }),
    });
    return response;
  } catch (error) {
    console.log("====POST_PHONE_NUMBER_VALIDATION_EXISTING_USER API====");
    console.log(error);
    throw error;
  }
}

// (기존 = 카카오톡) 전화번호 인증번호 확인 요청
type api_post_phone_number_validation_check_type = {
  phone_number: string;
  verification_code: string;
};
async function api_post_phone_number_validation_check(
  args: api_post_phone_number_validation_check_type
) {
  try {
    //console.log(' api_post_phone_number_validation_check', args);
    const phone_number = args["phone_number"];
    const verification_code = args["verification_code"];

    const response = await fetch(
      `${API_BASE_URL}/verify_phone?phone_number=${phone_number}&verification_code=${verification_code}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====POST_PHONE_NUMBER_VALIDATION_CHECK API====");

    console.log(error);
    throw error;
  }
}

// 국제 전화번호 인증번호 확인 요청
type api_post_international_phone_number_validation_check_type = {
  phone_number: string;
  verification_code: string;
  dial_code?: string;
};
async function api_post_international_phone_number_validation_check(
  args: api_post_international_phone_number_validation_check_type
) {
  try {
    //console.log(" api_post_international_phone_number_validation_check", args);
    const phone_number = args["phone_number"];
    const verification_code = args["verification_code"];
    const dial_code = args["dial_code"];
    const response = await fetch(
      `${API_BASE_URL}/twilio_message/verify?phone_number=${phone_number}&verification_code=${verification_code}&dial_code=${dial_code}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====POST_INTERNATIONAL_PHONE_NUMBER_VALIDATION_CHECK API====");

    console.log(error);
    throw error;
  }
}

// 기존 유저 전화번호 인증번호 확인 요청
type api_post_exist_phone_number_validation_check_type = {
  phone_number: string;
  verification_code: string;
  accessToken: string;
  is_naver: boolean;
};
async function api_post_exist_phone_number_validation_check(
  args: api_post_exist_phone_number_validation_check_type
) {
  try {
    const { phone_number, verification_code, accessToken, is_naver } = args;
    const response = await fetch(
      `${API_BASE_URL}/info/verify_phone?phone_number=${phone_number}&verification_code=${verification_code}&is_naver=${is_naver}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====POST_EXIST_PHONE_NUMBER_VALIDATION_CHECK API====");

    console.log(error);
    throw error;
  }
}

////////////////////////////////////////////////////////////
/////////////////////////SKU////////////////////////////
////////////////////////////////////////////////////////////
type api_get_skus_type = {
  accessToken: string;
  offset: number;
};
async function api_get_skus(args: api_get_skus_type) {
  try {
    const { accessToken, offset } = args;
    //console.log("api_get_skus 호출")
    // 기존에 userid 보냈는데 페이징 처리하면서 페이지 번호 보내야함.
    const response = await axios.get(`${API_BASE_URL}/sku?offset=${offset}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====GET_SKUS API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

type api_post_sku_refresh_type = {
  sku_id_list: string[];
  accessToken: string;
};

async function api_post_sku_refresh(args: api_post_sku_refresh_type) {
  try {
    const { sku_id_list, accessToken } = args;
    const response = await axios.post(
      `${API_BASE_URL}/sku/refresh`,
      {
        sku_id_list,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    //console.log("api_post_sku_refresh response", response.data);
    return response.data;
  } catch (error) {
    console.log("====POST_SKU_REFRESH API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        return error.response;
      }
    }
    throw error;
  }
}

type api_get_unrequested_skus_type = {
  accessToken: string;
};
async function api_get_unrequested_skus(args: api_get_unrequested_skus_type) {
  try {
    //console.log("api_get_unrequested_skus 호출")
    const { accessToken } = args;
    const response = await fetch(API_BASE_URL + "/sku/unrequested", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====GET_UNREQUESTED_SKUS API====");
    console.log(error);
    throw error;
  }
}

// 상세페이지에서 skuName 및 tag 수정 api
type api_update_sku_name_tag_type = {
  accessToken: string;
  skuName: string;
  skuTagId: string;
  skuId: string;
};
async function api_update_sku_name_tag(args: api_update_sku_name_tag_type) {
  try {
    const { accessToken, skuName, skuTagId, skuId } = args;
    const response = await axios.post(
      API_BASE_URL + "/sku/tag",
      {
        sku_id: skuId,
        tag_id: skuTagId,
        sku_name: skuName,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====PUT_SKU_TAG API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        return error.response;
      }
      return error;
    }
    throw error;
  }
}

type api_delete_sku_type = {
  userId: string;
  skuId: string;
  accessToken: string;
};
async function api_delete_sku(args: api_delete_sku_type) {
  try {
    const { userId, skuId, accessToken } = args;

    const response = await axios.delete(`${API_BASE_URL}/sku?userId=${userId}&skuId=${skuId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      timeout: 300000, // 5분 타임아웃 설정 (300,000 밀리초)
    });
    return response;
  } catch (error) {
    console.log("====DELETE SKU API====");
    console.log(error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        return error.response;
      }
      return error;
    }
    throw error;
  }
}

type api_get_clothes_type = {
  userId: string;
  skuId: string;
  accessToken: string;
};
async function api_get_clothes(args: api_get_clothes_type) {
  try {
    const { userId, skuId, accessToken } = args;
    const response = await axios.get(`${API_BASE_URL}/clothes?userId=${userId}&skuId=${skuId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====GET CLOTHES API====");
    console.log(error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

type api_get_generatedphotos_type = {
  userId: string;
  clothesId: string;
  accessToken: string;
  offset: number;
};
async function api_get_generatedphotos(args: api_get_generatedphotos_type) {
  //console.log("api_get_generatedphotos 호출")
  //console.log("api_get_generatedphotos args", args)
  try {
    const { userId, clothesId, accessToken, offset } = args;
    const response = await axios.get(
      `${API_BASE_URL}/generatedphoto?userId=${userId}&clothesId=${clothesId}&offset=${offset}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====GET GENERATEDPHOTOS API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

// generatedphoto를 redis에서 확인하는 api
type api_get_generatedphoto_redis_type = {
  userId: string;
  generatedPhotoIdList: string[];
  accessToken: string;
};
async function api_get_generatedphoto_redis(args: api_get_generatedphoto_redis_type) {
  try {
    const { generatedPhotoIdList, accessToken } = args;

    const form = new FormData();
    for (let generatedPhotoId of generatedPhotoIdList) {
      form.append("generated_photo_id_list", String(generatedPhotoId));
    }

    const response = await axios.post(`${API_BASE_URL}/check/generatedphoto`, form, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + accessToken,
      },
    });

    return response;
  } catch (error) {
    console.log("====GET GENERATEDPHOTO REDIS API====");
    console.log(error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

// regeneratedPhoto redis에서 확인하는 api
type api_get_regeneratedphotos_redis_type = {
  regeneratedPhotoIdList: string[];
  accessToken: string;
};
async function api_get_regeneratedphotos_redis(args: api_get_regeneratedphotos_redis_type) {
  try {
    const { regeneratedPhotoIdList, accessToken } = args;
    const form = new FormData();

    for (let regeneratedPhotoId of regeneratedPhotoIdList) {
      form.append("regenerated_photo_id_list", String(regeneratedPhotoId));
    }

    const response = await axios.post(`${API_BASE_URL}/check/regeneratedphoto`, form, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====GET REGENERATEDPHOTOS REDIS API====");
    console.log(error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        return error.response;
      }
    }
    throw error;
  }
}

type api_get_regeneratedphotos_type = {
  userId: string;
  generatedPhotoId: string;
  accessToken: string;
};
async function api_get_regeneratedphotos(args: api_get_regeneratedphotos_type) {
  try {
    const { userId, generatedPhotoId, accessToken } = args;
    const response = await axios.get(
      `${API_BASE_URL}/regeneratedphotos?userId=${userId}&generatedPhotoId=${generatedPhotoId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====GET REGENERATEDPHOTOS API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

type api_get_generation_setting_type = {
  accessToken: string;
  skuId: string;
  userId: string;
};
async function api_get_generation_setting(args: api_get_generation_setting_type) {
  try {
    const accessToken = args["accessToken"];
    const skuId = args["skuId"];
    const userId = args["userId"];
    const response = await fetch(
      `${API_BASE_URL}/generation/setting?skuId=${skuId}&userId=${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (response.status != 200) {
      return response;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("====GET GENERATION SETTING API====");
    console.log(error);
    throw error;
  }
}

type get_generation_setting_v2_api_type = {
  accessToken: string;
  sku_id: string;
};
async function get_generation_setting_v2_api(args: get_generation_setting_v2_api_type) {
  try {
    const accessToken = args["accessToken"];
    const skuId = args["sku_id"];
    const response = await fetch(`${API_BASE_URL}/api/v2/generation/setting?sku_id=${skuId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    //console.log("api 호출 response", response.body);
    if (response.status != 200) {
      const error = await response.json();
      //console.log("Error response body:", error);
      return error;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("====GET GENERATION SETTING API====");
    console.log(error);
    throw error;
  }
}

type api_get_background_setting_type = {
  accessToken: string;
  offset: number;
};
async function api_get_background_setting(args: api_get_background_setting_type) {
  try {
    const accessToken = args["accessToken"];
    const offset = args["offset"];

    const response = await fetch(`${API_BASE_URL}/api/v2/generation/option?offset=${offset}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    if (response.status != 200) {
      return response;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("====GET GENERATION SETTING API====");
    console.log(error);
    throw error;
  }
}

type api_get_model_setting_type = {
  accessToken: string;
};
async function api_get_model_setting(args: api_get_model_setting_type) {
  try {
    const accessToken = args["accessToken"];
    const response = await fetch(`${API_BASE_URL}/api/v2/traindata/model_face_image`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    if (response.status != 200) {
      return response;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("====GET GENERATION SETTING API====");
    console.log(error);
    throw error;
  }
}

type api_get_camera_angle_setting_type = {
  accessToken: string;
};
async function api_get_camera_angle_setting(args: api_get_camera_angle_setting_type) {
  try {
    const accessToken = args["accessToken"];
    const response = await fetch(`${API_BASE_URL}/traindata/camera_composition_data`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    if (response.status != 200) {
      return response;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("====GET CAMERA ANGLE SETTING API====");
    console.log(error);
    throw error;
  }
}

type api_get_basic_codi_type = {
  accessToken: string;
};
async function api_get_basic_codi(args: api_get_basic_codi_type) {
  try {
    const accessToken = args["accessToken"];
    const response = await fetch(`${API_BASE_URL}/traindata/codi_item`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    if (response.status != 200) {
      return response;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("====GET GENERATION SETTING API====");
    console.log(error);
    throw error;
  }
}

type api_get_generatedphoto_feedback_type = {
  generatedPhotoId: string;
  accessToken: string;
  userId: string;
};
async function api_get_generatedphoto_feedback(args: api_get_generatedphoto_feedback_type) {
  try {
    const generatedPhotoId = args["generatedPhotoId"];
    const accessToken = args["accessToken"];
    const userId = args["userId"];
    const response = await fetch(
      `${API_BASE_URL}/generatedphoto/feedback?generatedPhotoId=${generatedPhotoId}&userId=${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (response.status != 200) {
      return response;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("====GET GENERATEDPHOTO FEEDBACK API====");
    console.log(error);
    throw error;
  }
}

type api_post_generatedphoto_feedback_type = {
  generatedPhotoId: string;
  evaluation: number;
  review: string;
  accessToken: string;
  userId: string;
};
async function api_post_generatedphoto_feedback(args: api_post_generatedphoto_feedback_type) {
  try {
    const { generatedPhotoId, evaluation, review, accessToken, userId } = args;
    const response = await fetch(API_BASE_URL + "/generatedphoto/feedback", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify({
        generatedPhotoId: generatedPhotoId,
        evaluation: evaluation,
        review: review,
        userId: userId,
      }),
    });
    return response;
  } catch (error) {
    console.log("====POST GENERATEDPHOTO FEEDBACK API====");
    console.log(error);
    throw error;
  }
}

type api_get_presigned_url_type = {
  accessToken: string;
  userId: string;
  is_front_upper: boolean;
  is_front_lower: boolean;
  is_front_single: boolean;
  is_back_upper: boolean;
  is_back_lower: boolean;
  is_back_single: boolean;
};
async function api_get_presigned_url(args: api_get_presigned_url_type) {
  try {
    const {
      accessToken,
      userId,
      is_front_upper,
      is_front_lower,
      is_front_single,
      is_back_upper,
      is_back_lower,
      is_back_single,
    } = args;
    const response = await fetch(API_BASE_URL + "/api/traindata/upload_generate_presigned_url", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify({
        userId: userId,
        is_front_upper: is_front_upper,
        is_front_lower: is_front_lower,
        is_front_single: is_front_single,
        is_back_upper: is_back_upper,
        is_back_lower: is_back_lower,
        is_back_single: is_back_single,
      }),
    });
    return response;
  } catch (error) {
    console.log("====POST GENERATEDPHOTO FEEDBACK API====");
    console.log(error);
    throw error;
  }
}

type api_delete_generatedphoto_type = {
  generatedPhotoId: string;
  accessToken: string;
  userId: string;
};
async function api_delete_generatedphoto(args: api_delete_generatedphoto_type) {
  try {
    const { userId, accessToken, generatedPhotoId } = args;

    const response = await axios.delete(
      `${API_BASE_URL}/generatedphoto?generatedPhotoId=${generatedPhotoId}&userId=${userId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        timeout: 300000, // 5분 타임아웃 설정 (300,000 밀리초)
      }
    );
    return response;
  } catch (error) {
    console.log("====DELETE GENERATEDPHOTO API====");
    console.log(error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
      return error;
    }
    throw error;
  }
}

type api_delete_generatedphotos_type = {
  generatedPhotoIds: string[];
  accessToken: string;
  userId: string;
};
async function api_delete_generatedphotos(args: api_delete_generatedphotos_type) {
  try {
    const { generatedPhotoIds, accessToken, userId } = args;
    const form = new FormData();
    form.append("userId", userId);
    for (let generatedPhotoId of generatedPhotoIds) {
      form.append("generatedPhotoIds", generatedPhotoId);
    }

    const response = await axios.post(`${API_BASE_URL}/generatedphotos/delete`, form, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + accessToken,
      },
      timeout: 300000, // 5분 타임아웃 설정 (밀리초)
    });
    return response;
  } catch (error) {
    console.log("====DELETE GENERATEDPHOTOS API====");
    console.log(error);
    throw error;
  }
}

type api_post_generation_type = {
  userId: string;
  clothesId: string;
  codiItemId: string | undefined;
  backgroundId: string | undefined;
  poseId: string | undefined;
  batchSize: number | undefined;
  accessToken: string;
};
async function api_post_generation(args: api_post_generation_type) {
  try {
    const { userId, clothesId, codiItemId, backgroundId, poseId, batchSize, accessToken } = args;
    const response = await axios.post(
      API_BASE_URL + "/generation",
      {
        userId: userId,
        clothesId: clothesId,
        codiItemId: codiItemId,
        backgroundId: backgroundId,
        poseId: poseId,
        batchSize: batchSize,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        timeout: 420000, // 7분 타임아웃 설정 (420,000 밀리초)
      }
    );
    //console.log("api_post_generation response", response)
    return response;
  } catch (error) {
    console.log("====POST GENERATION API====");
    // console.log(error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return {
          data: error.response.data,
        };
      }
    }
    throw error;
  }
}

type api_post_generation_v2_type = {
  userId: string;
  clothesId: string;
  backgroundId: string;
  codiItemId: string;
  direction: number;
  accessToken: string;
  cameraCompositionId: string;
};
async function api_post_generation_v2(args: api_post_generation_v2_type) {
  try {
    const {
      userId,
      clothesId,
      backgroundId,
      codiItemId,
      direction,
      accessToken,
      cameraCompositionId,
    } = args;
    //console.log("api_post_generation_v2", args)
    const response = await axios.post(
      API_BASE_URL + "/api/v2/generation",
      {
        userId: userId,
        clothesId: clothesId,
        backgroundId: backgroundId,
        codiItemId: codiItemId || null,
        direction: direction,
        cameraCompositionId: cameraCompositionId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        timeout: 420000, // 7분 타임아웃 설정 (420,000 밀리초)
      }
    );
    //console.log("api_post_generation response", response)
    return response;
  } catch (error) {
    console.log("====POST GENERATION V2 API====");
    // console.log(error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return {
          data: error.response.data,
        };
      }
    }
    throw error;
  }
}

type api_post_regeneratedphoto_generation_type = {
  userId: string;
  accessToken: string;
  generatedPhotoId: string;
  clothesId: string;
  batchSize: number | undefined;
};
async function api_post_regeneratedphoto_generation(
  args: api_post_regeneratedphoto_generation_type
) {
  try {
    const { userId, clothesId, generatedPhotoId, batchSize, accessToken } = args;
    const response = await axios.post(
      API_BASE_URL + "/regeneratedphoto/generation",
      {
        userId,
        clothesId,
        generatedPhotoId,
        batchSize,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        timeout: 420000, // 7분 타임아웃 설정 (420,000 밀리초)
      }
    );
    return response;
  } catch (error) {
    console.log("====POST_REGENERATEDPHOTO_GENERATION API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        return error.response;
      }
    }
    throw error;
  }
}

type api_delete_regeneratedphotos_type = {
  userId: string;
  regeneratedPhotoIds: string[];
  accessToken: string;
};
async function api_delete_regeneratedphotos(args: api_delete_regeneratedphotos_type) {
  try {
    const { userId, regeneratedPhotoIds, accessToken } = args;
    const response = await axios.post(
      API_BASE_URL + "/regeneratedphotos/delete",
      {
        userId,
        regeneratedPhotoIds,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====DELETE_REGENERATEDPHOTOS API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        return error.response;
      }
    }
    throw error;
  }
}

type api_post_regeneratedphotos_download_type = {
  userId: string;
  regeneratedPhotoIds: string[];
  accessToken: string;
};
async function api_post_regeneratedphotos_download(args: api_post_regeneratedphotos_download_type) {
  try {
    const { userId, regeneratedPhotoIds, accessToken } = args;
    const response = await axios.post(
      API_BASE_URL + "/regeneratedphotos/download",
      {
        userId,
        regeneratedPhotoIds,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====POST_REGENERATEDPHOTOS_DOWNLOAD API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        return error.response;
      }
    }
    throw error;
  }
}

type api_get_user_type = {
  userId: string;
  accessToken: string;
};
async function api_get_user(args: api_get_user_type) {
  //console.log("api_get_user", args)
  try {
    const { userId, accessToken } = args;
    const response = await fetch(`${API_BASE_URL}/user?userId=${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====GET USER API====");
    console.log(error);
    throw error;
  }
}

//첫 크레딧 보너스 모달창에서 확인을 하면 업데이트
type api_post_update_first_login_time_type = {
  accessToken: string;
};
async function api_post_update_first_login_time(args: api_post_update_first_login_time_type) {
  //console.log("api_post_update_first_login_time", args)
  try {
    const { accessToken } = args;
    const response = await fetch(`${API_BASE_URL}/update_first_login_time`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====POST UPDATE FIRST LOGIN TIME API====");
    console.log(error);
    throw error;
  }
}

type api_get_email_duplication_type = {
  email: string;
};
async function api_get_email_duplication(args: api_get_email_duplication_type) {
  try {
    const email = args["email"];
    const response = await fetch(`${API_BASE_URL}/signup/email/duplication?email=${email}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.log("====GET EMAIL DUPLICATION API====");
    console.log(error);
    throw error;
  }
}

type api_post_password_validation_type = {
  password: string;
};
async function api_post_password_validation(args: api_post_password_validation_type) {
  try {
    const password = args["password"];
    const response = await fetch(`${API_BASE_URL}/signup/password/validation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        password: password,
      }),
    });
    return response;
  } catch (error) {
    console.log("====POST PASSWORD VALIDATION API====");
    console.log(error);
    throw error;
  }
}

type api_post_forgot_password_type = {
  email: string;
  language?: string;
};
async function api_post_forgot_password(args: api_post_forgot_password_type) {
  try {
    const { email, language } = args;
    const form = new FormData();
    form.append("email", email);
    if (language) form.append("language", language);

    const response = await fetch(`${API_BASE_URL}/login/forgot_password`, {
      method: "POST",
      body: form,
    });
    return response;
  } catch (error) {
    console.log("====POST FORGOT PASSWORD API====");
    console.log(error);
    throw error;
  }
}

type api_post_reset_password_type = {
  reset_token: string;
  password: string;
  confirm_password: string;
};
async function api_post_reset_password(args: api_post_reset_password_type) {
  try {
    const { reset_token, password, confirm_password } = args;
    const form = new FormData();
    form.append("reset_token", reset_token);
    form.append("password", password);
    form.append("confirm_password", confirm_password);

    const response = await axios.post(`${API_BASE_URL}/login/reset_password`, form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.log("====POST RESET PASSWORD API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

type api_post_generatedphotos_download_type = {
  generatedPhotoIds: string[];
  accessToken: string;
};
async function api_post_generatedphotos_download(args: api_post_generatedphotos_download_type) {
  try {
    const generatedPhotoIds = args["generatedPhotoIds"];
    const accessToken = args["accessToken"];
    const response = await fetch(API_BASE_URL + "/generatedphoto/download", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify({
        generated_photo_id_list: generatedPhotoIds,
      }),
    });
    if (response.status != 200) {
      return response;
    }
    const data = await response.json();
    // console.log("====POST GENERATEDPHOTO DOWNLOAD API RESPONSE====");
    // console.log(data);
    return data;
  } catch (error) {
    console.log("====POST GENERATEDPHOTOS DOWNLOAD API====");
    console.log(error);
    throw error;
  }
}

////////////////////////
////////////////////////
async function api_naver_login(token: string = "") {
  try {
    const response = await axios.get(`${API_BASE_URL}/auth/naver/login?token=${token}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.log("====GET_NAVER_LOGIN API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

////////////////////////
////////////////////////

type api_post_sku_clothes_type = {
  userId: string;
  accessToken: string;
  category: string;
  fitDetail: string;
  lengthDetail: string;
  gender: string;
  skuName: string;
  inputFilesList: File[][];
  frontViewIndexList: number[];
  isMannequinList: boolean[];
  tagId?: string;
};
async function api_post_sku_clothes(args: api_post_sku_clothes_type) {
  try {
    const {
      userId,
      accessToken,
      category,
      fitDetail,
      lengthDetail,
      gender,
      skuName,
      inputFilesList,
      frontViewIndexList,
      isMannequinList,
      tagId,
    } = args;

    const form = new FormData();
    form.append("userId", userId);
    form.append("category", category);
    form.append("fitDetail", fitDetail);
    form.append("lengthDetail", lengthDetail);
    form.append("gender", gender);
    form.append("skuName", skuName);
    if (tagId !== undefined) {
      form.append("tagId", tagId);
    }

    const rowSizes = inputFilesList.map((row) => row.length);
    form.append("rowSizes", JSON.stringify(rowSizes));

    inputFilesList.forEach((inputFiles) => {
      inputFiles.forEach((inputFile) => {
        form.append("inputFilesList", inputFile);
      });
    });

    for (let frontViewIndex of frontViewIndexList) {
      form.append("frontViewIndexList", String(frontViewIndex));
    }

    for (let isMannequin of isMannequinList) {
      form.append("isMannequinList", String(isMannequin));
    }
    // console.log("=== FormData Contents ===");
    // Array.from(form.entries()).forEach(([key, value]) => {
    //   console.log(`${key}:`, value);
    // });
    // console.log("=======================");
    // console.log("form", form);

    const response = await axios.post(`${API_BASE_URL}/traindata/sku_clothes`, form, {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

async function api_post_traindataUpload_v2(args: {
  accessToken: string;
  upper_json?: string;
  lower_json?: string;
  single_json?: string;
  sku_name: string;
  tag_id?: string;
  model_id?: string;
  background_id?: string;
  sku_id?: string;
  clothes_id?: string;
  high_quality_id?: string;
  camera_composition_id?: string;
}) {
  const {
    accessToken,
    upper_json,
    lower_json,
    single_json,
    sku_name,
    tag_id,
    model_id,
    background_id,
    sku_id,
    clothes_id,
    high_quality_id,
    camera_composition_id,
  } = args;

  const requestData = {
    upper_json,
    lower_json,
    single_json,
    sku_name: sku_name,
    tag_id: tag_id,
    model_id: model_id,
    background_id: background_id,
    sku_id: sku_id,
    clothes_id: clothes_id,
    high_quality_id: high_quality_id,
    camera_composition_id: camera_composition_id,
  };

  // 콘솔에 FormData 내용 출력
  //console.log('Request data:', requestData);

  try {
    const response = await axios.post(`${API_BASE_URL}/api/v2/traindata/upload`, requestData, {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
      timeout: 10000, // 10초 타임아웃 설정
    });

    return response;
  } catch (error) {
    //console.log("error", error);
    if (axios.isAxiosError(error) && error.code === "ECONNABORTED") {
      // 타임아웃 발생 시 처리
      //console.log("타임아웃 발생");
      return true;
    }
    // 다른 에러는 그대로 throw
    throw error;
  }
}

async function api_get_presigned_url_test(args: {
  accessToken: string;
  sku_id: string | null;
  clothes_id: string | null;
}) {
  try {
    const { accessToken, sku_id, clothes_id } = args;

    const requestBody = {
      sku_id: sku_id,
      clothes_id: clothes_id,
    };
    const response = await fetch(
      `${API_BASE_URL}/api/traindata/upload_generate_presigned_url_single`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + accessToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );
    return response.json();
  } catch (error) {
    console.log("====GET_PRESIGNED_URL_TEST API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

type TrainRequestData = {
  sku_id: string;
  sku_name: string;
  consuming_credit: number;
};
type post_train_request_type = {
  userId: string;
  accessToken: string;
  skuList: TrainRequestData[];
};
async function api_post_train_request(args: post_train_request_type) {
  try {
    const { userId, accessToken, skuList } = args;
    //console.log("userId", userId)

    // const form = new FormData();
    // //form.append("userId", userId);
    // for (let sku of skuList) {
    //   form.append("skuList", sku);
    // }
    //console.log("skuList", skuList)
    const requestBody = {
      train_request_data: skuList.map((sku) => ({
        sku_id: sku.sku_id,
        sku_name: sku.sku_name,
        consuming_credit: sku.consuming_credit,
      })),
    };
    //console.log('Request body:', requestBody); // 요청 본문 로깅

    const response = await fetch(`${API_BASE_URL}/traindata/train_request`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });
    if (!response.ok) {
      const errorText = await response.text();
      console.log("Error response:", errorText);
      return errorText;
    }
    return response;
  } catch (error) {
    console.log("====POST TRAIN_REQUEST API====");
    console.log(error);
    throw error;
  }
}

////////////////////////////////////////////////////////////
/////////////////////////PAYMENT////////////////////////////
////////////////////////////////////////////////////////////

type api_post_payment_request_type = {
  accessToken: string;
  orderData: {
    orderId: string;
    amount: number;
  };
};

async function api_post_payment_request(args: api_post_payment_request_type) {
  const { accessToken, orderData } = args;
  const response = await fetch(`${API_BASE_URL}/payment/request`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
    body: JSON.stringify({
      order_id: orderData.orderId, // camelCase를 snake_case로 변환
      amount: orderData.amount,
    }),
  });
  return response;
}

type api_post_payment_confirm_type = {
  accessToken: string;
  paymentData: {
    order_id: string;
    amount: number;
    payment_key: string;
    promotion_code: string;
  };
};

async function api_post_payment_confirm(args: api_post_payment_confirm_type) {
  const { accessToken, paymentData } = args;
  //console.log("api_post_payment_confirm paymentData:", paymentData);

  const response = await fetch(`${API_BASE_URL}/payment/confirm`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
    body: JSON.stringify({
      order_id: paymentData.order_id,
      amount: paymentData.amount,
      payment_key: paymentData.payment_key,
      promotion_code: paymentData.promotion_code,
    }),
  });
  return response;
}

type api_post_check_promote_code_type = {
  accessToken: string;
  promotion_code: string;
};
async function api_post_check_promote_code(args: api_post_check_promote_code_type) {
  const { accessToken, promotion_code } = args;
  //console.log("api_post_check_promote_code promotion_code:", promotion_code)
  const response = await fetch(`${API_BASE_URL}/promotion/code/validation`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + accessToken,
    },
    body: JSON.stringify({
      promotion_code: promotion_code,
    }),
  });
  return response;
}

// 엑심베이 결제 api
type api_post_payment_eximbay_type = {
  accessToken: string;
  orderData: {
    apply_num: string;
    bank_name: string;
    buyer_addr: string;
    buyer_email: string;
    buyer_name: string;
    buyer_postcode: string;
    buyer_tel: string;
    card_name: string;
    card_number: string;
    card_quota: number;
    currency: string;
    custom_data: string;
    imp_uid: string;
    merchant_uid: string;
    name: string;
    paid_amount: number;
    paid_at: number;
    pay_method: string;
    pg_provider: string;
    pg_tid: string;
    pg_type: string;
    receipt_url: string;
    status: string;
    success: boolean;
    promotion_code: string;
  };
};
async function api_post_payment_eximbay(args: api_post_payment_eximbay_type) {
  const { accessToken, orderData } = args;
  const response = await fetch(`${API_BASE_URL}/payment/en/success`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
    body: JSON.stringify({
      apply_num: orderData.apply_num,
      bank_name: orderData.bank_name,
      buyer_addr: orderData.buyer_addr,
      buyer_email: orderData.buyer_email,
      buyer_name: orderData.buyer_name,
      buyer_postcode: orderData.buyer_postcode,
      buyer_tel: orderData.buyer_tel,
      card_name: orderData.card_name,
      card_number: orderData.card_number,
      card_quota: orderData.card_quota,
      currency: orderData.currency,
      custom_data: orderData.custom_data,
      imp_uid: orderData.imp_uid,
      merchant_uid: orderData.merchant_uid,
      name: orderData.name,
      paid_amount: orderData.paid_amount,
      paid_at: orderData.paid_at,
      pay_method: orderData.pay_method,
      pg_provider: orderData.pg_provider,
      pg_tid: orderData.pg_tid,
      pg_type: orderData.pg_type,
      receipt_url: orderData.receipt_url,
      status: orderData.status,
      success: orderData.success,
      promotion_code: orderData.promotion_code,
    }),
  });
  return response;
}

type api_get_credit_recharge_info_type = {
  xApiKey?: string;
  accessToken?: string;
};
async function api_get_credit_recharge_info(args: api_get_credit_recharge_info_type) {
  const { accessToken, xApiKey } = args;
  //console.log("api_get_credit_recharge_info", args)
  // const response = await fetch(`${API_BASE_URL}/credit/product/list`, {
  //   method: "GET",
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: "Bearer " + accessToken,
  //   },
  // });

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    "x-api-key": xApiKey || "",
  };

  // Add Authorization header only if accessToken is provided
  if (accessToken) {
    headers.Authorization = "Bearer " + accessToken;
  }

  const response = await fetch(`${API_BASE_URL}/credit/product/list`, {
    method: "GET",
    headers,
  });
  //console.log("response", response)
  return response;
}

type api_post_paymentmethod_type = {
  userId: string;
  billingKey: string;
  customerKey: string;
  method: string;
  cardNumber: string;
  cardCompany: string;
  accessToken: string;
};
async function api_post_paymentmethod(args: api_post_paymentmethod_type) {
  try {
    const { userId, billingKey, customerKey, method, cardNumber, cardCompany, accessToken } = args;

    const response = await fetch(API_BASE_URL + "/payment/method", {
      method: "POST",
      body: JSON.stringify({
        userId: userId,
        billingKey: billingKey,
        customerKey: customerKey,
        method: method,
        cardNumber: cardNumber,
        cardCompany: cardCompany,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("====POST_PAYMENETMETHOD API====");
    console.log(error);
    throw error;
  }
}

type api_delete_paymentmethod_type = {
  user_id: string;
  accessToken: string;
};
async function api_delete_paymentmethod(args: api_delete_paymentmethod_type) {
  try {
    const { user_id, accessToken } = args;

    const response = await axios.delete(`${API_BASE_URL}/payment/method?user_id=${user_id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====DELETE_PAYMENTMETHOD API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

type api_get_payment_total_info_type = {
  accessToken: string;
};
async function api_get_payment_total_info(args: api_get_payment_total_info_type) {
  const { accessToken } = args;
  const response = await fetch(`${API_BASE_URL}/payment/info`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
  });
  //console.log("api_get_payment_total_info response", response)

  return response;
}

type api_get_userCreditInfo_type = {
  accessToken: string;
};
async function api_get_userCreditInfo(args: api_get_userCreditInfo_type) {
  const { accessToken } = args;
  const response = await fetch(`${API_BASE_URL}/user/credit`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
  });

  return response;
}

type api_get_payment_info_type = {
  userId: string;
  accessToken: string;
};
async function api_get_payment_info(args: api_get_payment_info_type) {
  const { userId, accessToken } = args;
  const searchParams = new URLSearchParams({ userId });
  const response = await fetch(`${API_BASE_URL}/payment?${searchParams.toString()}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
  });

  return response;
}

type api_get_payment_history_type = {
  userId: string;
  accessToken: string;
};
async function api_get_payment_history(args: api_get_payment_history_type) {
  const { userId, accessToken } = args;
  const searchParams = new URLSearchParams({ userId });
  const response = await fetch(`${API_BASE_URL}/payment/history?${searchParams.toString()}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
  });
  return response;
}

type api_get_payment_history_new_type = {
  accessToken: string;
  page?: number;
  limit?: number;
  status?: string;
};
async function api_get_payment_history_new(args: api_get_payment_history_new_type) {
  //console.log("api_get_payment_history_new args", args)
  const { accessToken, page, limit, status } = args;
  const searchParams = new URLSearchParams();

  // Add optional pagination parameters if provided
  if (page) searchParams.append("page", page.toString());
  if (limit) searchParams.append("limit", limit.toString());
  if (status) searchParams.append("status", status.toString());
  const response = await fetch(`${API_BASE_URL}/payment/history/new?${searchParams.toString()}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
  });
  return response;
}

type api_get_credit_history_new_type = {
  accessToken: string;
  page?: number;
  limit?: number;
  status?: string;
};
async function api_get_credit_history_new(args: api_get_credit_history_new_type) {
  const { accessToken, page, limit, status } = args;
  //console.log("api_get_credit_history_new args", args)
  const searchParams = new URLSearchParams();

  // Add optional pagination parameters if provided
  if (page) searchParams.append("page", page.toString());
  if (limit) searchParams.append("limit", limit.toString());
  if (status) searchParams.append("status", status.toString());

  const response = await fetch(`${API_BASE_URL}/credit/usage/detail?${searchParams.toString()}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
  });
  return response;
}

type api_get_billinghistory_type = {
  userId: string;
  accessToken: string;
};
async function api_get_billinghistory(args: api_get_billinghistory_type) {
  const { userId, accessToken } = args;
  const searchParams = new URLSearchParams({ userId });
  const response = await fetch(`${API_BASE_URL}/billing/history?${searchParams.toString()}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
  });
  return response;
}

type api_get_membership_type = {
  accessToken: string;
};
async function api_get_membership_info_v2(args: api_get_membership_type) {
  const { accessToken } = args;
  const response = await fetch(`${API_BASE_URL}/membershiptype/v2`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
  });
  return response;
}
async function api_get_membershiptype_info() {
  const response = await fetch(`${API_BASE_URL}/membershiptype`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
}
async function api_get_membershiptype_info_v2() {
  const response = await fetch(`${API_BASE_URL}/membershiptype/data/v2`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
}

type api_post_membership_type = {
  userId: string;
  accessToken: string;
  membershipTypeId: string;
};
async function api_post_membership_info(args: api_post_membership_type) {
  const { userId, accessToken, membershipTypeId } = args;
  const response = await fetch(`${API_BASE_URL}/membership`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
    body: JSON.stringify({
      userId,
      membershipTypeId,
    }),
  });
  return response;
}

type api_get_membership_change_info_type = {
  userId: string;
  newMembershipTypeId: string;
  accessToken: string;
};
async function api_get_membership_change_info(args: api_get_membership_change_info_type) {
  try {
    const { userId, newMembershipTypeId, accessToken } = args;
    console.log(
      `${API_BASE_URL}/membership/change/info?userId=${userId}&newMembershipTypeId=${newMembershipTypeId}`
    );
    const response = await axios.get(
      `${API_BASE_URL}/membership/change/info?userId=${userId}&newMembershipTypeId=${newMembershipTypeId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====GET_MEMBERSHIP_CHANGE_INFO API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

type api_get_sku_price_type = {
  userId: string;
  skuNum: number;
  accessToken: string;
};
async function api_get_sku_price(args: api_get_sku_price_type) {
  const { userId, skuNum, accessToken } = args;
  const response = await fetch(
    `${API_BASE_URL}/membership/sku/price?userId=${userId}&skuNum=${skuNum}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    }
  );
  return response;
}

type api_post_setting_profile_update_type = {
  userId: string;
  images?: File | string;
  name: string;
  brand: string;
  accessToken: string;
};
async function api_post_setting_profile_update(args: api_post_setting_profile_update_type) {
  const { userId, accessToken, images, name, brand } = args;
  const formData = new FormData();
  if (images && images instanceof File) {
    formData.append("images", images);
  }
  formData.append("name", name);
  formData.append("brand", brand);

  const response = await fetch(`${API_BASE_URL}/setting/profile_update`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
    body: formData,
  });
  return response.json();
}

type api_post_regeneratedphoto_feedback_type = {
  regeneratedPhotoId: string;
  evaluation: string;
  review: string;
  accessToken: string;
};
async function api_post_regeneratedphoto_feedback(args: api_post_regeneratedphoto_feedback_type) {
  try {
    const { regeneratedPhotoId, evaluation, review, accessToken } = args;

    const response = await axios.post(
      `${API_BASE_URL}/regeneratedphoto/feedback`,
      {
        regeneratedPhotoId: regeneratedPhotoId,
        evaluation: evaluation,
        review: review,
      },
      {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====POST_REGENERATEDPHOTO_FEEDBACK API====");
    console.log(error);
    throw error;
  }
}

type api_get_regeneratedphoto_feedback_type = {
  regeneratedPhotoId: string;
  accessToken: string;
};
async function api_get_regeneratedphoto_feedback(args: api_get_regeneratedphoto_feedback_type) {
  try {
    const { regeneratedPhotoId, accessToken } = args;
    const response = await axios.get(
      `${API_BASE_URL}/regeneratedphoto/feedback?regeneratedPhotoId=${regeneratedPhotoId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====GET_REGENERATEDPHOTO_FEEDBACK API====");
    console.log(error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

type api_post_scale_photo_obj_type = {
  photo_id: string;
  photo_url: string;
};
type api_post_scale_type = {
  photo_obj_list: api_post_scale_photo_obj_type[];
  upscale_size: number; // 2 or 4
  accessToken: string;
};
async function api_post_scale(args: api_post_scale_type) {
  try {
    const { photo_obj_list, upscale_size, accessToken } = args;
    const response = await axios.post(
      API_BASE_URL + "/upscale",
      {
        photo_obj_list,
        upscale_size,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        timeout: 420000, // 7분 타임아웃 설정 (420,000 밀리초)
      }
    );
    return response;
  } catch (error) {
    console.log("====POST_SCALE API====");
    // console.log(error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

// [로그아웃 API] session만 clear 해주는 것이라 따로 요소가 필요없음
async function api_get_logout(accessToken: string) {
  try {
    const response = await fetch(`${API_BASE_URL}/logout`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====GET LOGOUT API====");
    console.log(error);
    throw error;
  }
}

type api_get_sku_refresh_one_type = {
  sku_id: string;
  accessToken: string;
};

async function api_get_sku_refresh_one(args: api_get_sku_refresh_one_type) {
  //console.log("api_get_sku_refresh_one");
  try {
    const { sku_id, accessToken } = args;
    const response = await axios.get(`${API_BASE_URL}/sku/refresh/one?sku_id=${sku_id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====GET_SKU_REFRESH_ONE API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

////////////////////////////////////////////////////////////
/////////////////////////TAG////////////////////////////
////////////////////////////////////////////////////////////
type api_get_tags_type = {
  accessToken: string;
};
async function api_get_tags(args: api_get_tags_type) {
  try {
    const { accessToken } = args;
    const response = await axios.get(`${API_BASE_URL}/tag`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====GET_TAGS API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

type api_post_tags_type = {
  tag_title_list: string[];
  accessToken: string;
};
async function api_post_tags(args: api_post_tags_type) {
  try {
    const { tag_title_list, accessToken } = args;
    const response = await axios.post(
      `${API_BASE_URL}/tag`,
      {
        tag_title_list,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        timeout: 300000, // 5분 타임아웃 설정 (밀리초)
      }
    );
    return response;
  } catch (error) {
    console.log("====POST_TAG API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

type api_update_tag_type = {
  accessToken: string;
  tag_id: string;
  tag_title: string;
};
async function api_update_tag(args: api_update_tag_type) {
  try {
    const { accessToken, tag_id, tag_title } = args;
    const response = await axios.put(
      `${API_BASE_URL}/tag?tag_id=${tag_id}&tag_title=${tag_title}`,
      {}, // 두 번째 인자는 보낼 데이터 (없다면 빈 객체로)
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====UPDATE_TAG API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

type api_delete_tag_type = {
  accessToken: string;
  tag_id: string;
};
async function api_delete_tag(args: api_delete_tag_type) {
  try {
    const { accessToken, tag_id } = args;
    const response = await axios.delete(`${API_BASE_URL}/tag?tag_id=${tag_id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====DELETE_TAG API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
      return error;
    }
    throw error;
  }
}

type api_get_tag_count_type = {
  accessToken: string;
  tag_id: string;
};
async function api_get_tag_count(args: api_get_tag_count_type) {
  try {
    const { accessToken, tag_id } = args;
    const response = await axios.get(`${API_BASE_URL}/tag/count?tag_id=${tag_id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====GET_TAG_COUNT API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
    }
    throw error;
  }
}

type api_get_tag_sku_list_type = {
  accessToken: string;
  tag_id: string;
  offset: number;
};
async function api_get_tag_sku_list(args: api_get_tag_sku_list_type) {
  try {
    const { accessToken, tag_id, offset } = args;
    const response = await axios.get(
      `${API_BASE_URL}/tag/sku_list?tag_id=${tag_id}&offset=${offset}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====GET_TAG_SKU_LIST API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
      return error;
    }
    throw error;
  }
}

// 생성사진 좋아요
type api_post_generatedphoto_isliked_type = {
  accessToken: string;
  generated_photo_id: string;
  is_liked: boolean;
};
async function api_post_generatedphoto_isliked(args: api_post_generatedphoto_isliked_type) {
  try {
    const { accessToken, generated_photo_id, is_liked } = args;
    const form = new FormData();
    form.append("generated_photo_id", generated_photo_id);
    form.append("is_liked", String(is_liked));
    const response = await axios.post(API_BASE_URL + "/generatedphoto/isliked", form, {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====POST_GENERATEDPHOTO_ISLIKED API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        return error.response;
      }
      return error;
    }
    throw error;
  }
}

// 재생성사진 좋아요
type api_post_regeneratedphoto_isliked_type = {
  accessToken: string;
  regenerated_photo_id: string;
  is_liked: boolean;
};
async function api_post_regeneratedphoto_isliked(args: api_post_regeneratedphoto_isliked_type) {
  try {
    const { accessToken, regenerated_photo_id, is_liked } = args;
    const form = new FormData();
    form.append("regenerated_photo_id", regenerated_photo_id);
    form.append("is_liked", String(is_liked));
    const response = await axios.post(API_BASE_URL + "/regeneratedphoto/isliked", form, {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    });
    return response;
  } catch (error) {
    console.log("====POST_REGENERATEDPHOTO_ISLIKED API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        return error.response;
      }
      return error;
    }
    throw error;
  }
}

type api_get_generatedphotos_isliked_type = {
  accessToken: string;
  clothes_id: string;
};
async function api_get_generatedphotos_isliked(args: api_get_generatedphotos_isliked_type) {
  try {
    const { accessToken, clothes_id } = args;
    const response = await axios.get(
      `${API_BASE_URL}/generatedphotos/isliked?clothes_id=${clothes_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====GET_GENERATEDPHOTOS_ISLIKED API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
      return error;
    }
    throw error;
  }
}

type api_get_regeneratedphotos_isliked_type = {
  accessToken: string;
  generated_photo_id: string;
};
async function api_get_regeneratedphotos_isliked(args: api_get_regeneratedphotos_isliked_type) {
  try {
    const { accessToken, generated_photo_id } = args;
    const response = await axios.get(
      `${API_BASE_URL}/regeneratedphotos/isliked?generated_photo_id=${generated_photo_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====GET_REGENERATEDPHOTOS_ISLIKED API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
      return error;
    }
    throw error;
  }
}

async function api_get_customer_stories() {
  try {
    const response = await axios.get(`${API_BASE_URL}/customer/stories`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.log("====GET_CUSTOMER_STORIES API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
      return error;
    }
    throw error;
  }
}

type api_get_customer_story_type = {
  customer_story_id: string;
};
async function api_get_customer_story(args: api_get_customer_story_type) {
  try {
    const { customer_story_id } = args;
    const response = await axios.get(
      `${API_BASE_URL}/customer/story?customer_story_id=${customer_story_id}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====GET_CUSTOMER_STORY API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
      return error;
    }
    throw error;
  }
}

type api_post_customer_story_isliked_type = {
  customer_story_id: string;
  is_liked: boolean;
};
async function api_post_customer_story_isliked(args: api_post_customer_story_isliked_type) {
  try {
    const { customer_story_id, is_liked } = args;
    const response = await axios.post(
      `${API_BASE_URL}/customer/story/isliked`,
      {
        customer_story_id,
        is_liked,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.log("====GET_CUSTOMER_STORY API====");
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // status code != 200
        return error.response;
      }
      return error;
    }
    throw error;
  }
}

export {
  api_post_login,
  api_refresh_access_token,
  api_post_signup,
  api_post_social_signup,
  api_post_phone_number_validation,
  api_update_sku_name_tag,
  api_post_phone_number_validation_existing_user,
  api_post_phone_number_validation_check,
  api_post_exist_phone_number_validation_check,
  api_get_skus,
  api_post_sku_refresh,
  api_get_unrequested_skus,
  api_delete_sku,
  api_get_clothes,
  api_get_generatedphotos,
  api_get_regeneratedphotos,
  api_get_generation_setting,
  api_get_camera_angle_setting,
  get_generation_setting_v2_api,
  api_get_background_setting,
  api_get_generatedphoto_feedback,
  api_post_generatedphoto_feedback,
  api_delete_generatedphoto,
  api_get_generatedphoto_redis,
  api_delete_generatedphotos,
  api_post_generation,
  api_post_generation_v2,
  api_post_regeneratedphoto_generation,
  api_delete_regeneratedphotos,
  api_post_regeneratedphotos_download,
  api_get_user,
  api_post_update_first_login_time,
  api_get_email_duplication,
  api_get_model_setting,
  api_get_basic_codi,
  api_post_password_validation,
  api_post_forgot_password,
  api_post_reset_password,
  api_get_check_referral_code,
  api_post_check_coupon_code,
  api_post_generatedphotos_download,
  api_naver_login,
  api_post_traindataUpload_v2,
  api_post_sku_clothes,
  api_post_train_request,
  api_post_paymentmethod,
  api_post_payment_confirm,
  api_post_payment_request,
  api_delete_paymentmethod,
  api_get_credit_recharge_info,
  api_get_payment_info,
  api_get_credit_history_new,
  api_get_payment_history_new,
  api_get_payment_total_info,
  api_get_userCreditInfo,
  api_get_payment_history,
  api_get_billinghistory,
  api_get_membership_info_v2,
  api_get_membershiptype_info,
  api_get_membershiptype_info_v2,
  api_post_membership_info,
  api_get_membership_change_info,
  api_get_sku_price,
  api_post_setting_profile_update,
  api_post_regeneratedphoto_feedback,
  api_get_regeneratedphoto_feedback,
  api_post_scale,
  api_get_logout,
  api_get_sku_refresh_one,
  api_get_tags,
  api_post_tags,
  api_update_tag,
  api_delete_tag,
  api_get_tag_count,
  api_get_tag_sku_list,
  api_post_generatedphoto_isliked,
  api_post_regeneratedphoto_isliked,
  api_get_generatedphotos_isliked,
  api_get_regeneratedphotos_isliked,
  api_get_customer_stories,
  api_get_customer_story,
  api_post_customer_story_isliked,
  api_get_regeneratedphotos_redis,
  api_post_international_phone_number_validation,
  api_post_international_phone_number_validation_check,
  api_get_presigned_url,
  api_get_presigned_url_test,
  api_post_payment_eximbay,
  api_post_check_promote_code,
};
